import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem('passlux_user');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const [adminUser, setAdminUser] = useState(() => {
    try {
      const saved = localStorage.getItem('passlux_admin');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  useEffect(() => {
    if (user) localStorage.setItem('passlux_user', JSON.stringify(user));
    else localStorage.removeItem('passlux_user');
  }, [user]);

  useEffect(() => {
    if (adminUser) localStorage.setItem('passlux_admin', JSON.stringify(adminUser));
    else localStorage.removeItem('passlux_admin');
  }, [adminUser]);

  const login = (email, password) => {
    const users = JSON.parse(localStorage.getItem('passlux_users') || '[]');
    const found = users.find(u => u.email === email && u.password === password);
    if (found) {
      const userData = { id: found.id, name: found.name, email: found.email };
      setUser(userData);
      return { success: true, user: userData };
    }
    return { success: false, error: 'Invalid email or password' };
  };

  const register = (name, email, password) => {
    const users = JSON.parse(localStorage.getItem('passlux_users') || '[]');
    if (users.find(u => u.email === email)) {
      return { success: false, error: 'Email already exists' };
    }
    const newUser = { id: Date.now().toString(), name, email, password };
    users.push(newUser);
    localStorage.setItem('passlux_users', JSON.stringify(users));
    const userData = { id: newUser.id, name: newUser.name, email: newUser.email };
    setUser(userData);
    return { success: true, user: userData };
  };

  const logout = () => setUser(null);

  const adminLogin = (email, password) => {
    if (email === 'admin@luxo-market.com' && password === 'admin123') {
      const admin = { email, role: 'admin' };
      setAdminUser(admin);
      return { success: true };
    }
    return { success: false, error: 'Invalid admin credentials' };
  };

  const adminLogout = () => setAdminUser(null);

  return (
    <AuthContext.Provider value={{
      user, login, register, logout,
      adminUser, adminLogin, adminLogout,
      isAuthenticated: !!user,
      isAdmin: !!adminUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};
